import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppSharedFacade } from '@medsurf/flat-facades';
import { MediaControlService } from '@medsurf/flat-services';

@Component({
    selector: 'medsurf-carousel',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.scss'],
    standalone: false
})
export class CarouselComponent {
  /**
   * Constructor
   *
   * @param appSharedFacade
   * @param mediaControlService
   */
  public constructor(public appSharedFacade: AppSharedFacade,
                     public mediaControlService: MediaControlService) {
  }
}
